/*
 * @Author: 吴文洁
 * @Date: 2019-09-06 09:51:29
 * @LastEditors: liguokang
 * @LastEditTime: 2021-06-18 14:18:06
 * @Description:
 */
import Vue from 'vue';
import Vuex from 'vuex';
import modal from './modules/modal';
import spin from './modules/spin';
import institution from './modules/institution';
import student from './modules/student';
import userInfo from './modules/userInfo';
import underEnter from './modules/under-renter';
import curriculaVariable from './modules/curriculaVariable';
import Exhition from './modules/Exhibition';
import getters from './getters';

Vue.use(Vuex);

const store = new Vuex.Store({
  modules: {
    modal,
    spin,
    institution,
    student,
    underEnter,
    userInfo,
    curriculaVariable,
    Exhition,
  },
  getters,
});

export default store;



// WEBPACK FOOTER //
// ./src/store/index.js